export default "__VITE_ASSET__c4d6f744__"